import * as Yup from "yup";
import { wasteCodes } from "../../../../utils/dataAndFormulas/wasteForms";

export function initialValues(form, period, year, unitsRecorded, disposalMethodDefaults) {
  return {
    date: form?.date || "",
    creator_user: form?.creator_user || "",
    period: form?.period || period,
    year: form?.year || year,
    state: form?.state || "",
    paper_and_cardboard: form?.paper_and_cardboard || {
      code: wasteCodes["paper_and_cardboard"],
      unit: unitsRecorded?.["paper_and_cardboard"] || "",
      disposalMethod: disposalMethodDefaults?.["paper_and_cardboard"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    plastic: form?.plastic || {
      code: wasteCodes["plastic"],
      unit: unitsRecorded?.["plastic"] || "",
      disposalMethod: disposalMethodDefaults?.["plastic"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    fabric_scraps: form?.fabric_scraps || {
      code: wasteCodes["fabric_scraps"],
      unit: unitsRecorded?.["fabric_scraps"] || "",
      disposalMethod: disposalMethodDefaults?.["fabric_scraps"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    metal_clean: form?.metal_clean || {
      code: wasteCodes["metal_clean"],
      unit: unitsRecorded?.["metal_clean"] || "",
      disposalMethod: disposalMethodDefaults?.["metal_clean"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    wood: form?.wood || {
      code: wasteCodes["wood"],
      unit: unitsRecorded?.["wood"] || "",
      disposalMethod: disposalMethodDefaults?.["wood"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    food_waste: form?.food_waste || {
      code: wasteCodes["food_waste"],
      unit: unitsRecorded?.["food_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["food_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
     general_trash: form?.general_trash || {
      code: wasteCodes["general_trash"],
      unit: unitsRecorded?.["general_trash"] || "",
      disposalMethod: disposalMethodDefaults?.["general_trash"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    glass: form?.glass || {
      code: wasteCodes["glass"],
      unit: unitsRecorded?.["glass"] || "",
      disposalMethod: disposalMethodDefaults?.["glass"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    leather: form?.leather || {
      code: wasteCodes["leather"],
      unit: unitsRecorded?.["leather"] || "",
      disposalMethod: disposalMethodDefaults?.["leather"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    foam_eva: form?.foam_eva || {
      code: wasteCodes["foam_eva"],
      unit: unitsRecorded?.["foam_eva"] || "",
      disposalMethod: disposalMethodDefaults?.["foam_eva"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    empty_cans_or_containers:
      form?.empty_cans_or_containers || {
        code: wasteCodes["empty_cans_or_containers"],
        unit: unitsRecorded?.["empty_cans_or_containers"] || "",
        disposalMethod: disposalMethodDefaults?.["empty_cans_or_containers"] || null,
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    rubber: form?.rubber || {
      code: wasteCodes["rubber"],
      unit: unitsRecorded?.["rubber"] || "",
      disposalMethod: disposalMethodDefaults?.["rubber"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
      other_non_hazardous_waste: form?.other_non_hazardous_waste || {
      code: wasteCodes["other_non_hazardous_waste"],
      unit: unitsRecorded?.["other_non_hazardous_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["other_non_hazardous_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    electronic_waste: form?.electronic_waste || {
      code: wasteCodes["electronic_waste"],
      unit: unitsRecorded?.["electronic_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["electronic_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    empty_chemical_containers:
      form?.empty_chemical_containers || {
        code: wasteCodes["empty_chemical_containers"],
        unit: unitsRecorded?.["empty_chemical_containers"] || "",
        disposalMethod: disposalMethodDefaults?.["empty_chemical_containers"] || null,
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
          cleaning_pesticide_containers:
      form?.cleaning_pesticide_containers || {
        code: wasteCodes["cleaning_pesticide_containers"],
        unit: unitsRecorded?.["cleaning_pesticide_containers"] || "",
        disposalMethod: disposalMethodDefaults?.["cleaning_pesticide_containers"] || null,
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    batteries: form?.batteries || {
      code: wasteCodes["batteries"],
      unit: unitsRecorded?.["batteries"] || "",
      disposalMethod: disposalMethodDefaults?.["batteries"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    fluorescent_tubes: form?.fluorescent_tubes || {
      code: wasteCodes["fluorescent_tubes"],
      unit: unitsRecorded?.["fluorescent_tubes"] || "",
      disposalMethod: disposalMethodDefaults?.["fluorescent_tubes"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    cooking_oil: form?.cooking_oil || {
      code: wasteCodes["cooking_oil"],
      unit: unitsRecorded?.["cooking_oil"] || "",
      disposalMethod: disposalMethodDefaults?.["cooking_oil"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    maintenance_oil: form?.maintenance_oil || {
      code: wasteCodes["maintenance_oil"],
      unit: unitsRecorded?.["maintenance_oil"] || "",
      disposalMethod: disposalMethodDefaults?.["maintenance_oil"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    lubricants: form?.lubricants || {
      code: wasteCodes["lubricants"],
      unit: unitsRecorded?.["lubricants"] || "",
      disposalMethod: disposalMethodDefaults?.["lubricants"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    paint_waste: form?.paint_waste || {
      code: wasteCodes["paint_waste"],
      unit: unitsRecorded?.["paint_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["paint_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },

    coal_ashes: form?.coal_ashes || {
      code: wasteCodes["coal_ashes"],
      unit: unitsRecorded?.["coal_ashes"] || "",
      disposalMethod: disposalMethodDefaults?.["coal_ashes"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    rubber_hazardous: form?.rubber_hazardous || {
      code: wasteCodes["rubber_hazardous"],
      unit: unitsRecorded?.["rubber_hazardous"] || "",
      disposalMethod: disposalMethodDefaults?.["rubber_hazardous"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    chemicals: form?.chemicals || {
      code: wasteCodes["chemicals"],
      unit: unitsRecorded?.["chemicals"] || "",
      disposalMethod: disposalMethodDefaults?.["chemicals"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
       contaminated_materials: form?.contaminated_materials || {
      code: wasteCodes["contaminated_materials"],
      unit: unitsRecorded?.["contaminated_materials"] || "",
      disposalMethod: disposalMethodDefaults?.["contaminated_materials"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
       ink_cartridges: form?.ink_cartridges || {
      code: wasteCodes["ink_cartridges"],
      unit: unitsRecorded?.["ink_cartridges"] || "",
      disposalMethod: disposalMethodDefaults?.["ink_cartridges"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
       medical_waste: form?.medical_waste || {
      code: wasteCodes["medical_waste"],
      unit: unitsRecorded?.["medical_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["medical_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
       other_hazardous_waste: form?.other_hazardous_waste || {
      code: wasteCodes["other_hazardous_waste"],
      unit: unitsRecorded?.["other_hazardous_waste"] || "",
      disposalMethod: disposalMethodDefaults?.["other_hazardous_waste"] || null,
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
  };
}

export function validationSchema() {
  return Yup.object({
    period: Yup.string("Dato requerido").required(
      "El campo periodo es obligatorio"
    ),
    paper_and_cardboard: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    plastic: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    fabric_scraps: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    metal_clean: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    wood: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    food_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
     general_trash: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    glass: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    leather: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    foam_eva: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    empty_cans_or_containers: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    rubber: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
     other_non_hazardous_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    electronic_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    empty_chemical_containers: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
     cleaning_pesticide_containers: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    batteries: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    fluorescent_tubes: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    cooking_oil: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    maintenance_oil: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    lubricants: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    paint_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    coal_ashes: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    rubber_hazardous: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    chemicals: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    contaminated_materials: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    ink_cartridges: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    medical_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    other_hazardous_waste: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  });
}
